<div class="EFList {{ full ? 'EFList--Full' : vertical ? 'EFList--Vertical' : 'EFList--Horizontal'}}" role="region" [attr.aria-label]="'experience-finder.a11y.results-list' | locTranslate">
    <div class="row py-3">
        @if ((productsData == null || productsData.length == 0)) {
            <div class="mb-3 col-12">
                <h5 class="text-muted" role="status">{{ 'experience-finder.general.no-results' | locTranslate }}</h5>
            </div>
        }
        @if ((!vertical && !full) || (productsData != null && productsData.length > 0)) {
            @for (product of visibleProductsData; track product; let i = $index) {
                <div class="EFList-Item {{ full ? 'col-12 col-md-6 col-lg-4' : vertical ? 'col-12': oneItem ? 'col-10' : 'col-10 col-md-5 col-lg-4' }}">
                    <app-ef-product-card [productData]="product" [vertical]="vertical || full" (showProduct)="showProduct.emit($event)"></app-ef-product-card>
                </div>
            }
            <div class="EFList-Item {{ full ? 'col-12 col-md-6 col-lg-4' : vertical ? 'col-12': oneItem ? 'col-10' : 'col-10 col-md-5 col-lg-4' }}" [hidden]="visibleProductsData.length == productsData.length">
                <app-pg-view-more (viewMore)="viewMoreProducts()"></app-pg-view-more>
            </div>
        }
    </div>
</div>
